var englishLanguage = {
    AUTH_INVALID: "Something went wrong. We couldn’t find your profile. Please do the payment again.",
    ACCT_INACCESSIBLE: "We can’t access your Click to Pay account. Please try again later.",
    FRAUD: "Your Click to Pay account is locked or disabled. Please contact your card provider.",
    OTP_SEND_FAILED: "We couldn’t send the code.",
    OTP_SEND_FAILED_RESEND: "Click here to send again.",
    RETRIES_EXCEEDED: "Too many attempts. Please wait few minutes and try again.",
    SESSION_ID_INVALID: "Couldn’t connect to the service. Please try again.",
    VALDATA_MISSING: "We failed to connect to service. Please try again later.",
    CODE_INVALID: "Invalid code. Please try again.",
    CODE_EXPIRED: "The code has expired.",
    CODE_EXPIRED_SEND: "Send a new code.",
    CARD_MISSING: "We failed to add your card. Please try again",
    CARD_ADD_FAILED: "We failed to add your card. Please try again.",
    CARD_SECURITY_CODE_MISSING: "Please provide a security code.",
    CARD_INVALID: "Please enter valid card number.",
    CARD_EXP_INVALID: "Please enter valid card expiry date.",
    CARD_NOT_RECOGNIZED: "Card issuer currently not supported or card number invalid. Please try a different card or check card number.",
    MERCHANT_DATA_INVALID: "Service currently unavailable, payment was not proceeded. Please try again later.",
    UNABLE_TO_CONNECT: "Service currently unavailable, payment was not proceeded. Please try again later.",
    NO_INTERNET_CONNECTION: "No internet connection. Check your connection and try again.",
    PROFILE_LOAD_FAILED: "Something went wrong. Refresh the page and try again.",
    TERMS_AND_CONDITIONS_NOT_ACCEPTED: "Please accept Click to Pay terms and conditions.",
    SWW: "Something went wrong. Please try again.",
    EMAIL_NOT_DEFINED: "E\u2011mail address not defined.",
    EMAIL_INVALID: "E\u2011mail address is invalid.",
    OTP_EMPTY: "OTP cannot be empty.",
    OTP_RESENT: "The security code has been resent.",
    EMPTY_PROFILE_LIST: "No account found with this e\u2011mail address. Check your e\u2011mail or create a new account.",
    EMPTY_CARD_LIST_HEADER: "Looks like you have a Click to Pay account. Please add a card.",
};
export default englishLanguage;
